module.exports = __webpack_public_path__ + "img/logo-small@3x.63417173.png";